module.exports = __webpack_public_path__ + "img/w2b.f9b8320e.jpg";